import type { Category } from '../../types';
import SectionHeading from './SectionHeading';

interface CategorySectionProps {
  categories: Category[];
}

const CategorySection = ({ categories }: CategorySectionProps) => {
  return (
    <section className="section container" id="categorias">
      <SectionHeading
        overline="Categorías"
        title="Colecciones principales"
        description="Bloques listos para conectarse luego con páginas de listado, filtros o rutas independientes."
      />

      <div className="category-grid">
        {categories.map((category) => (
          <article key={category.id} className="category-card">
            <img src={category.image} alt={category.title} />
            <div className="category-card__overlay">
              <span>{category.itemCount} productos</span>
              <h3>{category.title}</h3>
              <p>{category.description}</p>
              <button type="button">Ver colección</button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default CategorySection;
